import { useObservableEagerState } from "observable-hooks";
import { useClientEnvironment } from "~/environment/ClientEnvironmentContext";

export function useIsOnline() {
  const { network } = useClientEnvironment();
  return useObservableEagerState(network.isOnline$);
}
